import { DROPDOWN_PAGE, panelDelete, panelGet, panelPost, panelPut, toArray } from "./panel.api";
import { Region, RegionPayload } from "./types";

/** region — /region */
export const regionApi = {
  getAll: () => panelGet<Region[]>("/region", DROPDOWN_PAGE),
  getById: (id: string) => panelGet<Region>(`/region/${id}`),
  create: (payload: RegionPayload) => panelPost<Region>("/region", payload),
  update: (id: string, payload: RegionPayload) => panelPut<Region>(`/region/${id}`, payload),
  remove: (id: string) => panelDelete(`/region/${id}`),
  /** The regions a category is offered in. */
  byCategory: (categoryId: string) => panelGet<Region[]>("/region/get-regions-by-category", { categoryId }),
  /** The regions across a category's per-region copies, each naming the copy it came from. */
  byCategories: (categoryIds: string[]) =>
    Promise.all(
      categoryIds.map((categoryId) =>
        regionApi
          .byCategory(categoryId)
          .then((rows: any) =>
            toArray(rows).map((region: any) => ({
              id: region.id ?? region.regionId,
              regionName: region.regionName ?? region.name,
              categoryId,
            }))
          )
          .catch(() => [] as { id: string; regionName: string; categoryId: string }[])
      )
    ).then((lists) =>
      lists
        .flat()
        .filter((region, index, all) => all.findIndex((other) => other.id === region.id) === index)
        .sort((a, b) => String(a.regionName ?? "").localeCompare(String(b.regionName ?? "")))
    ),
  /** A region's categories, sub-regions and vendors (v2.1). */
  drilldown: (id: string) => panelGet<any>(`/region/${encodeURIComponent(id)}/drilldown`),
};
